import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getName } from '../../../Redux/selecters';
import CommunityDetails from './communityDetails';
import { fetchCommunityCountries, fetchCommunityCitiesByCountry } from './communityApiHelpers';

const emptyForm = () => ({
  communityNo: '',
  descriptionEn: '',
  descriptionAr: '',
  country: null,
  city: null,
  marketingDescription: '',
  remarks: '',
});

const CreateCommunity = () => {
  const apiService = new LeaseApiService();
  const navigate = useNavigate();
  const userName = useSelector(getName);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(emptyForm());
  const [countriesList, setCountriesList] = useState([]);
  const [cityList, setCityList] = useState([]);

  useEffect(() => {
    fetchDropdownData();
  }, []);

  const fetchDropdownData = async () => {
    try {
      const countries = await fetchCommunityCountries(apiService);
      setCountriesList(countries);
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  };

  const handleCountryChange = async (selectedOption) => {
    setFormData((prev) => ({ ...prev, country: selectedOption, city: null }));
    if (!selectedOption?.label) {
      setCityList([]);
      return;
    }
    try {
      const cities = await fetchCommunityCitiesByCountry(apiService, selectedOption.label);
      setCityList(cities);
    } catch (error) {
      console.error('Error fetching cities:', error);
      setCityList([]);
    }
  };

  const buildPayload = (currentDatetimeUTC) => ({
    community: {
      record_ID: '0',
      communityNo: formData.communityNo || '0',
      description: formData.descriptionEn || '0',
      city: formData.city?.label || '0',
      country: formData.country?.label || '0',
      createdBy: userName || '',
      createdOn: currentDatetimeUTC,
      modifiedBy: userName || '',
      modifiedOn: currentDatetimeUTC,
    },
  });

  const handleSave = async () => {
    if (!formData.communityNo?.trim()) {
      toast.warning('Please enter Community Number');
      return;
    }
    if (!formData.descriptionEn?.trim()) {
      toast.warning('Please enter Description En');
      return;
    }
    if (!formData.country) {
      toast.warning('Please select Country');
      return;
    }
    if (!formData.city) {
      toast.warning('Please select City');
      return;
    }

    try {
      setLoading(true);
      const currentDatetimeUTC = new Date().toISOString();
      const body = buildPayload(currentDatetimeUTC);
      const res = await apiService.post('POST_COMMUNITY', body);
      if (res?.data?.isSuccessful || res?.data?.statusCode === 200 || res?.data?.statusCode === 201) {
        toast.success(res?.data?.message || 'Community created');
        navigate('/Customer/Property/Master/Community/Listing');
      } else {
        toast.warning(res?.data?.message || 'Create failed');
      }
    } catch (error) {
      console.error('Error creating community:', error);
      toast.error('Failed to create community');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-3">
      <div className="border-box2 p-2 d-flex justify-content-between align-items-center" style={{ borderRadius: '8px' }}>
        <h6 className="mb-0">Community Master Management</h6>
        <div className="d-flex gap-3">
          {loading ? (
            <div className="mainbtn flex-end gap-2">
              <ClipLoader color="#ffffff" className="mt-1" size={25} />
            </div>
          ) : (
            <div className="mainbtn flex-end gap-2" onClick={handleSave}>
              <FaSave color="#fff" className="center mt-1 mx-2" />
              <div className="center">Save</div>
            </div>
          )}
          <div className="mainbtnSecondary flex-end gap-2" onClick={() => window.history.back()}>
            <FaChevronLeft color="#fff" className="center mt-1 mx-2" />
            <div className="center">Back</div>
          </div>
        </div>
      </div>

      <CommunityDetails formData={formData} setFormData={setFormData} countriesList={countriesList} cityList={cityList} onCountryChange={handleCountryChange} />
    </div>
  );
};

export default CreateCommunity;
